import React from "react";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.css";
import $ from "jquery";
import Popper from "popper.js";
import "bootstrap/dist/js/bootstrap.bundle.min";
import * as axios from "../src/core/services/axios";
import * as Sentry from "@sentry/react";
import LocalStorageService from "./core/services/local-storage.service";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "./redux/store";

const localStorageService = LocalStorageService.getService();
const userDetails = localStorageService.getUserDetails();

if (process.env.NODE_ENV.toLowerCase() === "production") {
  disableConsole();
  initPendo();
  initSentry();
}

function initSentry() {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_KEY,
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
    ignoreErrors: ["Network Error", "Request failed with status code"],
    release: `${process.env.REACT_APP_BRANCH}_${process.env.REACT_APP_COMMIT_ID}`,
    initialScope: (scope) => {
      scope.setTags({
        userDetails: JSON.stringify({
          userDetails: JSON.stringify(userDetails?.email_address),
        }),
      });
      return scope;
    },
    environment: process.env.REACT_APP_HOST_ENV || process.env.NODE_ENV,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

function initPendo() {
  const email = userDetails?.email_address;
  const comingFrom = window.location.search?.includes("comingFrom");
  const id = email || (comingFrom ? "signInFromWebsite" : "");

  window.pendo.initialize({
    visitor: { id },
    account: { id },
  });
}

function disableConsole() {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
  console.warn = () => {};
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
